import { ApplicationConfig, APP_INITIALIZER, importProvidersFrom, InjectionToken } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app-routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HttpClient, HttpHeaders, HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { CacheService } from 'src/Services/cache.service';
import { v4 as uuidv4 } from 'uuid';
import { ChatBotService } from 'src/Services/chat-bot.service';
import { CachingInterceptor } from './interceptors/caching.interceptor';
import { UuidInterceptor } from './interceptors/uuid.interceptor';
import { LoaderInterceptor } from './interceptors/loading.interceptor';
import { environment } from 'src/environments/environment';
import { LoggerModule, NGXLogger, NgxLoggerLevel, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { firstValueFrom } from 'rxjs';
import { ServerCustomizedService } from 'src/Services/server-customized.service';
import { provideEnvironmentNgxMask } from 'ngx-mask'
import { CommonService } from 'src/Services/common.service';
import { SilentLoadingInterceptor } from './interceptors/silent-loading.interceptor';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
export function initApp(chatBotService: ChatBotService) {
  return () => chatBotService.getEnvironmentProperties();
}

function generateHttpHeadersWithUUID(): HttpHeaders {
  let uuid = sessionStorage.getItem('appUUID');
  if (!uuid) {
    uuid = uuidv4();
    sessionStorage.setItem('appUUID', uuid);
  }

  return new HttpHeaders({
    'X-Request-ID': uuid
  });
}

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideClientHydration(), provideEnvironmentNgxMask(),
  { provide: LocationStrategy, useClass: HashLocationStrategy },
  provideHttpClient(
    withFetch(), // Enable the fetch API for HttpClient
    withInterceptorsFromDi()
  ),
    TranslateService, CacheService, {
    provide: APP_INITIALIZER,
    useFactory: initApp,
    deps: [ChatBotService],
    multi: true
  },
  
  { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UuidInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SilentLoadingInterceptor, multi: true },

  importProvidersFrom(TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
    LoggerModule.forRoot({
      level: environment.logLevel,
      disableConsoleLogging: environment.disableConsoleLogging,
      enableSourceMaps: environment.enableSourceMaps,
      serverLogLevel: NgxLoggerLevel.INFO,
      serverLoggingUrl: environment.hostUrl + '/bot-api/logging',
      customHttpHeaders: generateHttpHeadersWithUUID()
    },
      {
        serverProvider: {
          provide: TOKEN_LOGGER_SERVER_SERVICE, useClass: ServerCustomizedService
        }
      }),),
  ]
};
